import "core-js/modules/es.number.constructor";
//
//
//
//
//
//
import { ContentPlaceholders, ContentPlaceholdersHeading, ContentPlaceholdersText } from 'vue-content-placeholders';
export default {
  components: {
    ContentPlaceholders: ContentPlaceholders,
    ContentPlaceholdersHeading: ContentPlaceholdersHeading,
    ContentPlaceholdersText: ContentPlaceholdersText
  },
  props: {
    lines: {
      type: Number,
      default: 10
    }
  }
};